import React, { useEffect,  } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch } from 'react-redux'
import useAuth from '../../context/auth/useAuth'
import { Link, useParams, useNavigate } from 'react-router-dom'

export default function Dashboard() { 
  	const { t } = useTranslation()
	const dispatch = useDispatch()
    const navigate = useNavigate()
	const {client} = useAuth()
    const { restaurantid } = useParams()

	useEffect(() => {
		if(client){
            if(client?.rol==='Kitchen'){
                navigate('/kitchen/dashboard')
            }
		}
	},[dispatch, t, client])

	return (
        <Container className='p-5'> 
            <Row className="mb-3">
                <Col xs={2} className='p-0'>
                    <Link className="p-0 my-3" to="/kitchen/takerestaurant">
                        <img src="../../images/arrow-back.svg" alt="arrow-back" width={25}></img>
                    </Link>
                </Col>
                <Col xs={8}></Col>
                <Col xs={2}></Col>
            </Row>
            <Row>
                <Col>
                    <Link to={"/kitchen/ordersfordelivery/"+restaurantid} className='btn btn-dashboard btn-dashboard-white'>
                        {t('kitchen.dashboard.ordersfordelivery')}
                    </Link>
                    <Link to={"/kitchen/ordersdelivered/"+restaurantid} className='btn btn-dashboard btn-dashboard-white'>
                        {t('kitchen.dashboard.ordersdelivered')}
                    </Link>
                </Col>
            </Row>
        </Container>
	)
}